module.exports = __webpack_public_path__ + "static/headerimg@2x-93237013eb311cf1f57585fb90d3c398.png";